const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWashingMachineSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.571 16.571",
    style: {
      enableBackground: "new 0 0 16.571 16.571"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff"
    },
    cx: 10.235,
    cy: 1.945,
    r: 0.852
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff"
    },
    cx: 12.816,
    cy: 1.945,
    r: 0.852
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M14.111,0H2.46C1.9,0,1.443,0.447,1.443,0.997l0.059,14.465c0,0.611,0.498,1.109,1.109,1.109 h11.347c0.612,0,1.11-0.498,1.11-1.109l0.059-14.465C15.128,0.447,14.672,0,14.111,0z M14.329,15.463 c0,0.203-0.166,0.369-0.37,0.369H2.612c-0.204,0-0.37-0.166-0.37-0.369V4.114c0-0.144,0.083-0.272,0.215-0.334h11.657 c0.133,0.062,0.215,0.19,0.215,0.334V15.463z M14.388,2.84c0,0.115-0.084,0.216-0.206,0.247H2.389 C2.268,3.057,2.183,2.956,2.183,2.84V0.997c0-0.142,0.124-0.257,0.277-0.257h11.651c0.152,0,0.276,0.115,0.276,0.257V2.84H14.388z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M8.285,4.826c-2.74,0-4.962,2.222-4.962,4.962s2.222,4.962,4.962,4.962s4.963-2.222,4.963-4.962 C13.248,7.048,11.026,4.826,8.285,4.826z M12.271,9.958c0,2.201-1.784,3.984-3.985,3.984c-2.2,0-3.984-1.783-3.984-3.984 s0.635-1.263,3.984,0.806C11.635,12.831,12.271,7.756,12.271,9.958z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWashingMachineSvgrepoCom);
export default __webpack_public_path__ + "static/media/washing-machine-svgrepo-com.60dc2cb5f2d99af5527b9bd24d22c596.svg";
export { ForwardRef as ReactComponent };